// extracted by mini-css-extract-plugin
module.exports = {"hsink":"LoginButton_hsink__2hh6U","tvprtch":"LoginButton_tvprtch__1V8WK"};